/*
 * @Descripttion: 关怀任务创建页
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import Panel from '@/components/Panel';
import React, { useState, createContext, Context, useEffect } from 'react';
import ActivityEffect from './components/ActivityEffect';
import ActivityName from './components/ActivityName';
import ActivityTime from './components/ActivityTime';
import PaymentReminderType from './components/PaymentReminderType';
import PutPeriod from './components/PutPeriod';
import TriggerEvent from './components/TriggerEvent';
import styles from './index.module.scss';
import CONSTANTS from './constant';
import UTIL_CONSTANTS from '@/utils/constant';
import GoalSetting from './components/GoalSetting';
import PutSetting from './components/PutSetting';
import OtherSetting from './components/OtherSetting';
import { Button, Loading } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import { appHistory } from '@ice/stark-app';
import { Servlets } from '@/service';
import moment from 'moment';
export const ActivityContext: Context<any> = createContext({});

const CreateTasks = (props) => {
  const { type, task, taskId } = props.match.params;
  const [pageLoading, setPageLoading] = useState(true);
  const [pageDisable, setPageDisable] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [activityEndDate, setActivityEndDate] = useState(0);// 软件订购剩余时间
  const [taskParams, setTaskParams] = useState({
    taskName:`${CONSTANTS.CARE_LIST[task]}_${moment().format('YYYY-MM-DD_HH:mm')}`,//任务名称
    taskType:task,//任务类型
    taskTimeType:1,//任务时间类型 1不限制 2自定义时间
    startTime:'',//任务开始时间  无限制取当前
    endTime:'', //任务结束时间   无限制取订购结束时间
    triggerEvent: {
      //触发事件  下单没有有了再说
      [task]:{
        ...CONSTANTS.TRIGGER_EVENT_DEFAULT_VALUE[task]
      },
    },
    launchTime:{
      type: 1, // 1-不限制,2 限制每天什么时间 配合 下面2个字段
      startTime: '',
      endTime: ''
    },
    orderCondition: {
      conditionRelation: 1, //条件关系 1-且，2-或
      orderStatus: CONSTANTS.ACTIVITY_TYPE_DATA[task].defaultOrderStatus, //订单状态 ；1-待支付；2-备货中；3-已发货；4-已取消；5-已完成，6售后中
      orderType: CONSTANTS.ACTIVITY_TYPE_DATA[task].orderTypeList[0], //订单类型  0-全部订单 1-在线支付，2-货到付款
      orderAmount: '0-0', //订单金额 0-0 不限制
      skuConfig: {
        //商品限制
        type: 1, //类型 1-不限制 ，2-指定 ，3-排除
        ids: []
      },
      skuNum: '0-0' //商品数量 0-0 不限制
    },
    areaCondition: {
      type: 1, //类型 1-不限制 ，2-指定 ，3-排除
      ids: []
    },
    sendContent: {
      smsContent: '',
      sign: '',
      showContent: '',
      contentLength: 0,
      smsSplitNum: 1
    },
    taskPriority: 1,
    adCap: 0,   //投放上限 0 不限制  
    adCnt: 0,   //投放次数   勾选 1  不勾选 0
    smsSurplusLess: 0   //短信余额不足   0-关闭任务。。。 1-保持开启。。。
  });
  const verification=[
    {tips:'活动名称不能为空',condition:!taskParams.taskName},
    {tips:'活动名称最大支持32个字',condition:taskParams.taskName.length>32},
    {tips:'请确认活动时效是否填写完整',condition:taskParams.taskTimeType === 2 && (!taskParams.startTime || !taskParams.endTime)},
    {tips:'请确认投放时段是否填写完整',condition:taskParams.launchTime.type === 2 && (!taskParams.launchTime.startTime|| !taskParams.launchTime.endTime)},
    {tips:'请输入触发事件',condition:(task ==='S_DDCF' || task === 'S_YCFH' || task ==='S_YSCF' || task === 'S_FKGH' || task === 'S_DDCP') && !taskParams.triggerEvent[task].number},
    {tips:'请选择触发事件',condition:(task ==='S_SHSQ' || task === 'S_JJSH' || task ==='S_TYTK' || task === 'S_SHCG') && taskParams.triggerEvent[task].triggerType.length===0},
    {tips:'订单金额不能为空',condition:!taskParams.orderCondition.orderAmount.split('-')[0] || !taskParams.orderCondition.orderAmount.split('-')[1]},
    {tips:'请输入正确的订单金额区间',condition:taskParams.orderCondition.orderAmount.split('-')[0] && taskParams.orderCondition.orderAmount.split('-')[1] && (+taskParams.orderCondition.orderAmount.split('-')[1] < +taskParams.orderCondition.orderAmount.split('-')[0])},
    {tips:'请选择限制商品',condition:(+taskParams.orderCondition.skuConfig.type===2 || +taskParams.orderCondition.skuConfig.type===3)&& taskParams.orderCondition.skuConfig.ids.length===0},
    {tips:'商品数量不能为空',condition:!taskParams.orderCondition.skuNum.split('-')[0] || !taskParams.orderCondition.skuNum.split('-')[1]},
    {tips:'请输入正确的商品数量区间',condition:taskParams.orderCondition.skuNum.split('-')[0]&&taskParams.orderCondition.skuNum.split('-')[1]&&(+taskParams.orderCondition.skuNum.split('-')[1] < +taskParams.orderCondition.skuNum.split('-')[0])},
    {tips:'请选择限制地区',condition:(+taskParams.areaCondition.type===2 || +taskParams.areaCondition.type===3)&&taskParams.areaCondition.ids.length===0},
    {tips:'请输入短信内容',condition:!taskParams.sendContent.smsContent},
    {tips:'请输入投放上限',condition:!taskParams.adCap && taskParams.adCap!==0},
  ]
  //  获取剩余天数
  const getShopTitle = () => {
    Servlets('getTitle', {}).then((res: any) => {
      setActivityEndDate(res.data.remainingDay);
    });
  };
  const saveTask = () => {
  console.log(taskParams,'=========参数⭐')
   let finalFlag = verification.every((item)=>{
      let flag = true;
      if(item.condition) {
        LzMsg.error(item.tips);
        flag = false;
        return false;
      }
      return flag;
    })
    if(finalFlag) {
      let newTaskParams = {
        ...taskParams,
        startTime:taskParams.taskTimeType === 1 ? moment().startOf('day').format('x') : moment(taskParams.startTime).format('x'),
        endTime:taskParams.taskTimeType === 1 ?moment().add(activityEndDate, 'days').endOf('day').format('x')  : moment(taskParams.endTime).endOf('day').format('x') ,
        sendContent:{
          ...taskParams.sendContent,
          smsContent: `${taskParams.sendContent.smsContent} ${UTIL_CONSTANTS.LZ_SMS_CANCEL_WORD}`,
          showContent: `${taskParams.sendContent.showContent} ${UTIL_CONSTANTS.LZ_SMS_CANCEL_WORD}`,
        }
      }
      Servlets('getOrderCareTasksName', {}).then((res) => {
        const duplicateName = res.data.find((v) => v === newTaskParams.taskName);
        if (duplicateName) {
          LzMsg.error('任务名已存在');
        } else {
          Servlets('getOrderCareTasksPriority', {taskType:task}).then((res) => {
            const duplicatePriority = res.data.find((v) => v === newTaskParams.taskPriority);
            if (duplicatePriority) {
              LzMsg.error('任务优先级已存在');
            } else {
              Servlets('saveOrderCare', newTaskParams).then((res:{success,data,resp_msg}) =>
              {
                if (res.success) {
                  LzMsg.success('保存成功');
                  appHistory.push('../../../care');
                }else {
                  LzMsg.error(res.resp_msg);
                }
              }).catch((e) => {
                console.log(e);
                LzMsg.error(e.message);
              });
            }
          });
        }
      });
    }
  }
  useEffect(()=>{
    if(taskParams.sendContent.sign && type!=='create') {
      if(type==='view') setPageDisable(true);
      Servlets('getOrderCareDetail', {taskId}).then((res:{success,data,resp_msg}) =>
      {
        if (res.success) {
          let newTaskParams = {
            ...res.data,
            taskName:type==='edit' ? `${res.data.taskName}副本` : res.data.taskName,
            taskTimeType:type==='edit' ? 1 : res.data.taskTimeType,
            startTime:type==='edit' ? '': res.data.taskTimeType === 2 ? moment(res.data.startTime).format('YYYY-MM-DD') : '',
            endTime:type==='edit' ? '': res.data.taskTimeType === 2 ? moment(res.data.endTime).format('YYYY-MM-DD') : '',
            sendContent:{
              ...res.data.sendContent,
              smsContent: res.data.sendContent.smsContent.replace(` ${UTIL_CONSTANTS.LZ_SMS_CANCEL_WORD}`, ''),
              showContent:res.data.sendContent.showContent.replace(` ${UTIL_CONSTANTS.LZ_SMS_CANCEL_WORD}`, ''),
            }
          }
          setTaskParams(newTaskParams);
          setRefresh(true);
          setPageLoading(false);
          console.log(newTaskParams,'========================res.data')
        }else {
          LzMsg.error(res.resp_msg);
        }
      }).catch((e) => {
        console.log(e);
        LzMsg.error(e.message);
        setPageLoading(false);
      });
    }
    if(type==='create') setPageLoading(false);
  },[taskParams.sendContent.sign])
  useEffect(()=>{
    getShopTitle();
  },[])
  return (
    <ActivityContext.Provider
      value={{
        task,
        taskParams,
        setTaskParams,
        type,
        pageDisable,
        refresh
      }}
  >
    <Loading visible={pageLoading}>
      <div className={styles['orderCareCreateBox']}>
        <Panel title='活动设置'>
          <ActivityEffect/>
          <ActivityName/>
          <ActivityTime/>
          { task === 'S_YSCF' && <PaymentReminderType/> }
          <TriggerEvent/>
          <PutPeriod/>
        </Panel>
        <Panel title='目标设置'>
          <GoalSetting/>
        </Panel>
        <Panel title='投放设置'>
          <PutSetting/>
        </Panel>
        <Panel title='其他设置'>
          <OtherSetting/>
        </Panel>
        <div className={styles['btn-box']}>
          {
            type !=='view' &&
            <Button
              type='primary'
              onClick={saveTask}
            >
              保存创建
            </Button>
          }
          <Button
            type='normal'
            style={{marginLeft:'10px',width:'88px'}}
            onClick={()=>{
              appHistory.push('../../../care')
            }}
          >
            {type ==='view' ? '返回' : '取消'}
          </Button>
        </div>
      </div>
    </Loading>
    </ActivityContext.Provider>
  );
};

export default CreateTasks;
